// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"e32bd2f3","585":"883ab282"}[chunkId] + ".chunk.js";
};